import WaveBackground from "@/components/landing/WaveBackground";
import LandingNavbar from "@/components/landing/LandingNavbar";
import HeroSection from "@/components/landing/HeroSection";
import FeaturesSection from "@/components/landing/FeaturesSection";
import Pricing from "@/components/landing/Pricing";
import LandingFooter from "@/components/landing/LandingFooter";
import CTASection from "@/components/landing/CTASection";

interface LandingPageProps {
  appName?: string;
  tagline?: string;
  description?: string;
}

const LandingPage = ({
  appName = "Hydranaut",
  tagline = "Master Your Service Ecosystem",
  description = "Complete visibility into services, teams and infrastructure."
}: LandingPageProps) => {
  return (
    <div className="relative min-h-screen">
      <WaveBackground />
      <div className="relative z-10">
        <LandingNavbar appName={appName} />
        <main>
          <HeroSection
            appName={appName}
            tagline={tagline}
            description={description}
          />
          <FeaturesSection />
          <Pricing />
          <CTASection />
        </main>
        <LandingFooter appName={appName} />
      </div>
    </div>
  );
};

export default LandingPage;
